import type { NewShipmentNotificationConfig } from '../../../../domain/types/configs/company/NotificationConfig';

export const newShipmentNotificationConfig: NewShipmentNotificationConfig = {
  recipients: [
    {
      contact: "epinzon@promed-sa.com",
      send: false,
      company: "VANGUARD"
    }
  ]
};